


















//@ts-ignore
import Router from "vue-router"; // Needed for $router
import Vue, { PropType } from "vue";
import { ICreateTab, ITab, ITabGroupData, ITabGroupComputed, ITabGroupMethods, ITabGroupProps } from "./TypeDefs";
import { Position } from "@/utils";
import "./scss";

const TabGroup = Vue.extend<ITabGroupData, ITabGroupMethods, ITabGroupComputed, ITabGroupProps>({
  name: "TabGroup",
  props: {
    tabs: {
      type: Array as PropType<(ICreateTab | ITab)[]>,
      required: true,
    },
  },
  data(): ITabGroupData {
    return {
      selectedTab: undefined,
    };
  },
  computed: {
    tabs_(): ITab[] {
      const tabs = this.tabs.map(
        (tab: ICreateTab): ITab => {
          const displayName = typeof tab.displayName === "function" ? tab.displayName.call(this, this) : tab.displayName;
          const tabNameSections = displayName.split(" ");
          const icon = tab.icon || tabNameSections[tabNameSections.length - 1].toLowerCase();
          return {
            id: tab.id,
            displayName,
            selected: tab.selected || false,
            icon: tab.icon || this.$icons[icon],
            position: tab.position || Position.Left,
          };
        }
      );

      return tabs;
    },
    leftTabs(): ITab[] {
      return this.tabs_.filter((tab: ITab) => tab.position === Position.Left);
    },
    rightTabs(): ITab[] {
      return this.tabs_.filter((tab: ITab) => tab.position === Position.Right);
    },
  },
  watch: {
    tabs() {
      const newSelectedTab = this.tabs_.find((tab: ITab) => tab.selected);
      if (newSelectedTab !== this.selectedTab) {
        this.selectedTab = newSelectedTab;
      }
    },
  },
  created() {
    if (this.tabs && this.tabs.length > 0) {
      const tabId = this.$route.query.tabId as string;
      if (tabId && (!this.selectedTab || tabId !== this.selectedTab.id)) {
        const selectTab = this.tabs_.find(t => t.id == tabId);
        if (selectTab) {
          this.onChange(selectTab);
        }
      } else if (!this.selectedTab) {
        const selectedTab = this.tabs_.find(tab => tab.selected) || this.tabs_[0];
        this.onChange(selectedTab);
      }
    }
  },
  methods: {
    onChange(tab: ITab): void {
      this.$emit("selected", tab);
    },
  },
});

export default TabGroup;
